// src/components/SelectedPhotosPage.js
import React, { useState, useEffect } from "react";
import logoFacomLong from "./../../images/LOGOFACOMLONG.png";
import gainsImg from "./../../images/GarageLego.png";
import * as apiCall from "./../../api/apiCall";
import "./Winner.css";

const Winner = ({ gain, email }) => {
  const [mailSent, setMailSent] = useState(false);

  async function sendMail(email, gain) {
    try {
      await apiCall.sendMail(email, gain);
    } catch (error) {
      console.error("Error fetching config:", error);
    }
  }
  useEffect(() => {
    if (!mailSent) {
      sendMail(email, gain);
      setMailSent(true); // Marquer l'email comme envoyé
    }
  }, [email, gain, mailSent]);

  return (
    <div className="header">
      <div className="logo">
        <img src={logoFacomLong} />
      </div>
      <div className="title">
        <div className="headerTitle">FÉLICITATIONS !</div>
        <div className="underTitle">
          Vous avez gagné{" "}
          <span style={{ color: "red" }}> {gain.gainsName}</span>
        </div>
      </div>
      <div className="gainsDisplay">
        <img src={gain.image} />
        <div className="headerTitle">{gain.gainsName}</div>
      </div>
      <div className="footerInfos">
        <div className="textFooter">
          <div style={{ textAlign: "center" }}>
            Nous allons vous contacter par email et vous transmettre votre gain
            🙂
          </div>
          Un petit post sur les réseaux sociaux avec #mercifacom nous fera le
          plus grand plaisir ! N'oubliez pas également de créer votre compte
          client sur <a href="https://facom.fr">facom.fr</a> pour intégrer notre
          programme de fidélité et gagner d'autres cadeaux !
        </div>
        <div
          className="secondChance"
          onClick={() =>
            window.open("https://www.facom.fr/account/login", "_blank")
          }
        >
          Je crée mon compte
        </div>
      </div>
    </div>
  );
};

export default Winner;
